// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"d24d900a","646":"27c20388"}[chunkId] + ".chunk.css";
};